export const traducciones = {
  1: {
    es: {
      id: 1,
      titlePortfolio: "Portafolio",
      title: "Soluciones a la medida",
      title2: "Desarrollamos software que se adapta a ti.",
      description: "Creamos sistemas personalizados diseñados específicamente para las necesidades de tu negocio o proyecto. Desde plataformas web hasta soluciones internas de gestión, cada desarrollo parte de tus procesos reales para ofrecer una herramienta eficiente, segura y funcional.",
      description2: "",
      description3: "",
      list1: "Automatización de procesos",
      list2: "Sistemas administrativos y operativos",
      list3: "Aplicaciones web progresivas (PWA)",
      list4: "Integración de APIs",
      list5: "Soluciones escalables y optimizadas",
      description4: "",
      textTecnology: "¿Tienes una idea? Nosotros la convertimos en una solución concreta.",
      tecnology: "React, HTML, CSS, JavaScript",
      imageUrl: "img/solutions/solutions_img1.svg",
      imageUrl2: "img/solutions/solutions_img2.svg",
      textUrl: "Contáctanos",
      url: "/contact",
    },
    en: {
      id: 1,
      titlePortfolio: "Portfolio",
      title: "Solutions tailored to your needs",
      title2: "We develop software that is tailored to you.",
      description: "We create custom systems specifically designed to meet the needs of your business or project. From web platforms to internal management solutions, every development is based on your actual processes to deliver an efficient, secure, and functional tool.",
      description2: "",
      description3: "",
      list1: "Automated processes",
      list2: "Administrative and operational systems",
      list3: "Progressive web applications (PWA)",
      list4: "API integration",
      list5: "Scalable and optimized solutions",
      description4: "",
      textTecnology: "Have an idea? We turn it into a concrete solution.",
      tecnology: "React, HTML, CSS, JavaScript",
      imageUrl: "img/solutions/solutions_img1.svg",
      imageUrl2: "img/solutions/solutions_img2.svg",
      textUrl: "Contact us",
      url: "/contact",
    }
  },
  2: {
    es: {
      id: 2,
      titlePortfolio: "Portfolio",
      title: "Productos en desarrollo",
      title2: "Soluciones propias, listas para potenciar tu negocio.",
      description: "Además del desarrollo a la medida, trabajamos en iniciativas pensadas para cubrir necesidades comunes en distintas industrias. Son propuestas robustas, en constante evolución, listas para ayudarte a optimizar tareas clave sin empezar desde cero.",
      description2: "",
      description3: "",
      list1: "Innovación aplicada a diferentes sectores",
      list2: "Procesos optimizados para mayor eficiencia",
      list3: "Herramientas digitales en constante evolución",
      list4: "Soluciones adaptables a cada necesidad",
      list5: "",
      description4: "",
      textTecnology: "Robustes y optimización en procesos clave desde el primer día.",
      tecnology: "",
      imageUrl: "img/solutions/solutions_img3.svg",
      imageUrl2: "img/solutions/solutions_img4.svg",
      textUrl: "¡Hablemos!",
      url: "/contact",

    },
    en: {
      id: 2,
      titlePortfolio: "Portfolio",
      title: "Self-developed products",
      title2: "Own solutions, ready to boost your business",
      description: "In addition to custom development, we work on initiatives designed to cover common needs across different industries. These are robust, constantly evolving proposals, ready to help you optimize key tasks without starting from scratch.",
      description2: "",
      description3: "",
      list1: "Innovation applied to different sectors",
      list2: "Optimized processes for greater efficiency",
      list3: "Digital tools in constant evolution",
      list4: "Adaptable solutions for every need",
      list5: "",
      description4: "",
      textTecnology: "Robust solutions, optimized in key processes from the first day.",
      tecnology: "",
      imageUrl: "img/solutions/solutions_img3.svg",
      imageUrl2: "img/solutions/solutions_img4.svg",
      textUrl: "Let's talk! ",
      url: "/contact",
    },
  },
  3: {
    es: {
      id: 3,
      titlePortfolio: "Portfolio",
      title: "Todo lo que necesitas, sin gastar de más",
      title2: "Tu presencia online, sin complicaciones",
      description: "Sabemos que muchos emprendedores necesitan una página web profesional sin invertir grandes sumas. Por eso, ofrecemos un paquete accesible, ideal para quienes están dando sus primeros pasos o quieren digitalizar su negocio de forma rápida y efectiva.",
      description2: "",
      description3: "",
      list1: "Sitios web desarrollados con CMS",
      list2: "Diseño adaptable a tu marca",
      list3: "Totalmente responsivos (PC, tablet y móvil)",
      list4: "Información clara de productos/servicios, contacto, redes sociales y ubicación",
      list5: "Entrega rápida y optimización básica para buscadores (SEO)",
      description4: "",
      textTecnology: "Una solución profesional, simple y asequible para empezar con el pie derecho en el mundo digital.",
      tecnology: "",
      imageUrl: "img/solutions/solutions_img5.svg",
      imageUrl2: "img/solutions/solutions_img6.svg",
      textUrl: "¡Comencemos!",
      url: "/contact",

    },
    en: {
      id: 3,
      titlePortfolio: "Portfolio",
      title: "All you need, without overpaying",
      title2: "Your online presence, without complications",
      description: "We know that many entrepreneurs need a professional website without investing large sums. That's why we offer an accessible package, ideal for those who are taking their first steps or want to digitalize their business quickly and effectively.",
      description2: "",
      description3: "",
      list1: "Websites developed with CMS",
      list2: "Adaptable design to your brand",
      list3: "Fully responsive (PC, tablet and mobile)",
      list4: "Clear information about products/services, contact, social media and location",
      list5: "Fast delivery and basic SEO optimization",
      description4: "",
      textTecnology: "A professional solution, simple and affordable to start right in the digital world.",
      tecnology: "",
      imageUrl: "img/solutions/solutions_img5.svg",
      imageUrl2: "img/solutions/solutions_img6.svg",
      textUrl: "Let's start! ",
      url: "/contact",
    },
  }
  
};